import {injectable} from "inversify";
import {Entity} from "tick-knock";
import {ContinentModel} from "@game/coregame/model/ContinentModel";

@injectable()
export class Field extends Entity {
    private _fieldId: string;

    init(levelModel: ContinentModel): this {
        this._fieldId = levelModel.data.id;
        return this;
    }
}
